import _ from "lodash";
import moment from "moment";
import { ACTIVITIES_CONST } from "@/store/modules/basic_activities/constants";

function convertProgramActivityAddModel(data, response, phaseId) {
  let model = {
    programPhaseId: phaseId,
    activityCode: response.title,
    activityId: response.id,
    description: response.shortText,
    programId: data.programId,
    programName: data.programName,
    isCustomized: false,
    activityType: data.type
  };
  return model;
}

function convertProgramActivityUpdateModel(data, phaseId) {
  let model = {
    id: data.id,
    activityCode: data.activityCode,
    activityId: data.activityId,
    description: data.shortText,
    programId: data.programId,
    isCustomized: true,
    programPhaseId: phaseId,
    activityType: data.type
  };
  return model;
}

function convertProgramActivityBulkAddModel(data, customActivities) {
  let addModel = [];
  customActivities.forEach(element => {
    let item = {
      activityCode: element.title,
      activityId: element.id,
      description: element.shortText,
      programId: data.programId,
      programName: data.programName,
      isCustomized: false
    };
    addModel.push(item);
  });
  return addModel;
}

function getListCustomActivityIds(items) {
  let ids = [];
  _.forEach(items, function(item) {
    ids.push(item.activityId);
  });
  return ids.join(",");
}

function convertCustomActivitiesToCalendar(data) {
  let calendarActivities = [];
  _.forEach(data, function(item) {
    if (item.startDate && item.endDate) {
      let endDate = new Date(item.endDate);
      endDate.setDate(endDate.getDate() + 1);
      let calendarItem = {
        title: item.title,
        start: moment(String(item.startDate)).format("YYYY/MM/DD"),
        end: moment(String(endDate)).format("YYYY/MM/DD")
      };
      calendarActivities.push(calendarItem);
    }
  });
  return calendarActivities;
}
function convertActivityTemplatesViewModel(activities, assignActs) {
  let result = [];
  if (activities && activities.data) {
    activities.data.forEach(item => {
      let type = item.type.toLowerCase().replace("_", "-");
      let temp = item;
      temp.Id = item.id;
      temp.Name = item.title;
      temp.Type = type.charAt(0).toUpperCase() + type.slice(1);
      temp.Category = item.category.name;
      temp.Pillar = item.category.thumbnailUrl;
      temp.Custom = "";
      temp.name = item.title;
      temp.pillar = item.category.thumbnailUrl;
      temp.type = type.charAt(0).toUpperCase() + type.slice(1);
      if (assignActs && assignActs.length > 0) {
        const index = assignActs.findIndex(t => t.apActId === item.id);
        if (index >= 0) {
          temp.Id = assignActs[index].apActId;
          temp.ProgramActivityId = assignActs[index].programActId;
          temp.Custom = "Custom";
        }
      }
      if (temp.sizeOfActivity === ACTIVITIES_CONST.SIZE.INDIVIDUAL) {
        temp.Participation = "Individual";
      } else if (temp.sizeOfActivity === ACTIVITIES_CONST.SIZE.TEAM) {
        temp.Participation = "Team";
      } else {
        temp.Participation = "All-Company";
      }
      result.push(temp);
    });
  }
  return result;
}

function convertLevelActivitiesViewModel(activitiesAP, activitiesProg) {
  let result = [];
  if (activitiesAP && activitiesAP.data) {
    activitiesAP.data.forEach(item => {
      let type = item.type.toLowerCase().replace("_", "-");
      let temp = item;
      temp.Id = item.id;
      temp.Name = item.title;
      temp.StartDate = item.startDate;
      temp.EndDate = item.endDate;
      temp.Pillar = item.category.thumbnailUrl;
      temp.Type = type.charAt(0).toUpperCase() + type.slice(1);
      temp.Category = item.category.name;
      temp.selected = false;
      temp._rowVariant = "";
      if (activitiesProg) {
        const index = activitiesProg.findIndex(
          t => t.ActivityId.toString() === item.Id.toString()
        );
        if (index >= 0) {
          temp.ProgramActivityId = activitiesProg[index].Id;
          temp.Phase = activitiesProg[index].ProgramPhasePhaseOrder;
          temp.SubgroupId = activitiesProg[index].SubgroupId;
          temp.SubgroupName = activitiesProg[index].SubgroupName;
        }
      }
      result.push(temp);
    });
  }
  return result;
}

function convertLevelActivitiesWithSubgroupViewModel(
  activitiesAP,
  activitiesProg
) {
  let result = [];
  if (activitiesAP && activitiesAP.data) {
    activitiesProg.forEach(o => {
      let temp = {
        ProgramActivityId: o.Id,
        Phase: o.ProgramPhasePhaseOrder,
        SubgroupId: o.SubgroupId,
        SubgroupName: o.SubgroupName,
        requirementItemId: o.requirementItemId,
        isRequirementItem: o.isRequirementItem
      };
      const index = activitiesAP.data.findIndex(
        t => o.ActivityId.toString() === t.id.toString()
      );
      if (index >= 0) {
        let activity = activitiesAP.data[index];
        temp = Object.assign({ ...temp, ...activitiesAP.data[index] });
        let type = activity.type.toLowerCase().replace("_", "-");
        temp.Id = activity.id;
        temp.Name = activity.title;
        temp.StartDate = activity.startDate;
        temp.EndDate = activity.endDate;
        temp.Pillar = activity.category.thumbnailUrl;
        temp.Type = type.charAt(0).toUpperCase() + type.slice(1);
        temp.Category = activity.category.name;
        temp.selected = false;
        temp._rowVariant = "";
      }
      result.push(temp);
    });
  }
  return result;
}

function convertProgramActivitiesViewModel(activitiesProg) {
  let result = [];
  if (activitiesProg && activitiesProg.data) {
    activitiesProg.data.forEach(item => {
      let type =
        item.activityType && item.activityType.toLowerCase().replace("_", "-");
      let temp = item;
      temp.Name = item.title;
      temp.StartDate = item.startDate;
      temp.EndDate = item.endDate;
      temp.Pillar = item.category && item.category.thumbnailUrl;
      temp.Type = type && type.charAt(0).toUpperCase() + type.slice(1);
      temp.Category = item.category && item.category.name;
      temp.selected = false;
      temp._rowVariant = "";
      temp.ProgramActivityId = item.id;
      temp.Custom = item.isCustomized ? "Custom" : "";
      if (temp.sizeOfActivity === ACTIVITIES_CONST.SIZE.INDIVIDUAL) {
        temp.Participation = "Individual";
      } else if (temp.sizeOfActivity === ACTIVITIES_CONST.SIZE.TEAM) {
        temp.Participation = "Team";
      } else {
        temp.Participation = "All-Company";
      }
      result.push(temp);
    });
  }
  return result;
}

function convertLevelActivity(data) {
  let activity = {
    activityCode: data.ActivityCode,
    activityId: data.ActivityId,
    id: data.Id,
    programLevelDescription: data.ProgramLevelDescription,
    programLevelId: data.ProgramLevelId
  };
  return activity;
}

function convertListLevelActivitiesModel(data) {
  let listActivity = [];
  let levelId = data.LevelId;
  let currentActs = data.LevelActivities;
  let assignActs = data.AssignActivities;
  let unassignActs = data.UnassignActivities;

  // Remove activities from unassigned acts
  if (currentActs && currentActs.length > 0) {
    if (unassignActs && unassignActs.length > 0) {
      currentActs.forEach(currentAct => {
        let unAssignIndex = unassignActs.findIndex(
          t => t.Id.toString() === currentAct.ActivityId.toString()
        );
        if (unAssignIndex < 0) {
          listActivity.push(addActivityModel(currentAct, levelId));
        }
      });
    } else {
      currentActs.forEach(currentAct => {
        listActivity.push(addActivityModel(currentAct, levelId));
      });
    }
  }
  // Add activities from assigned acts
  if (assignActs && assignActs.length > 0) {
    assignActs.forEach(newAct => {
      let newItem = {
        activityCode: newAct.title,
        activityId: newAct.Id,
        programLevelDescription: newAct.shortText,
        programLevelId: levelId
      };
      listActivity.push(newItem);
    });
  }
  return listActivity;
}

function addActivityModel(activity, levelId) {
  return {
    activityCode: activity.ActivityCode,
    activityId: activity.ActivityId,
    programLevelDescription: activity.Description,
    programLevelId: levelId,
    id: activity.Id
  };
}

export default {
  convertLevelActivitiesViewModel,
  convertActivityTemplatesViewModel,
  convertProgramActivityBulkAddModel,
  convertProgramActivityAddModel,
  convertProgramActivityUpdateModel,
  getListCustomActivityIds,
  convertCustomActivitiesToCalendar,
  convertProgramActivitiesViewModel,
  convertListLevelActivitiesModel,
  convertLevelActivity,
  convertLevelActivitiesWithSubgroupViewModel
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_activities/transform.js